const CLOSED_STATUSES = new Set(['completed', 'closed', 'collected', 'cancelled', 'voided'])

function clean(value) {
  return String(value || '').trim()
}

export function isAdministrativelyClosed(job = {}) {
  return Boolean(job.administrative_closed_at)
}

export function canAdministrativelyCloseJob(profile = {}, job = {}) {
  return clean(profile.role) === 'owner'
    && clean(profile.workshop_id) === clean(job.workshop_id)
    && clean(job.payment_status) === 'paid'
    && Boolean(job.payment_paid_at)
    && !CLOSED_STATUSES.has(clean(job.status).toLowerCase())
}

export function suspensionAdministrativeCloseMissing(job = {}) {
  const missing = []
  if (!job.inspection_completed_at) missing.push('Inspection is incomplete')
  if (clean(job.qc_status).toLowerCase() !== 'passed' || !job.qc_signed_off_at) {
    missing.push('Final QC is not passed and signed off')
  }
  if (!job.report_sent_at) missing.push('Customer report has not been sent')
  return missing
}

export function generalAdministrativeCloseMissing(job = {}, checklistSummary = {}) {
  const missing = []
  if (!checklistSummary.hasChecklists) {
    missing.push('Required General checklist is not present')
  } else if (
    (checklistSummary.blockers || []).length > 0
    || (checklistSummary.progress || []).some(row => row.done !== true)
  ) {
    missing.push('Required General checklist stages are incomplete')
  }
  if (!job.report_sent_at) missing.push('Customer report has not been sent')
  return missing
}
